import AsyncStorage from '@react-native-async-storage/async-storage';
import { useEffect, useState } from 'react';

import { STORAGE_KEYS } from '@/config';

/**
 * First-launch intro gate. `null` while the persisted flag is still loading,
 * then `true`/`false`. Fails OPEN (treats storage errors as "seen") so a
 * storage failure never traps the user on the intro screen forever.
 */
export function useHasSeenIntro(): boolean | null {
  const [seen, setSeen] = useState<boolean | null>(null);
  useEffect(() => {
    let mounted = true;
    AsyncStorage.getItem(STORAGE_KEYS.seenIntro)
      .then((value) => {
        if (mounted) setSeen(value === 'true');
      })
      .catch(() => {
        if (mounted) setSeen(true);
      });
    return () => {
      mounted = false;
    };
  }, []);
  return seen;
}

/** Persist that the intro has been seen. Resolves even if storage fails. */
export async function markIntroSeen(): Promise<void> {
  try {
    await AsyncStorage.setItem(STORAGE_KEYS.seenIntro, 'true');
  } catch {
    // Non-fatal: the user just sees the intro again next launch.
  }
}
